import * as React from 'react';
import { ContentView } from '@levelapp/softfabric';
import ResearchInputViewStyle from './ResearchInputViewStyle';
import ResearchInputViewModel from './ResearchInputViewModel';
import { View, Text, TextInput, TouchableWithoutFeedback } from 'react-native';
export default class ResearchInputView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new ResearchInputViewModel(this), new ResearchInputViewStyle(this));
    }
    /* RENDERING */
    render() {
        return (React.createElement(View, { style: this.style.input },
            React.createElement(View, { style: this.style.textInFront },
                React.createElement(Text, null, this.props.textInFront)),
            React.createElement(View, { style: this.style.containerInput },
                React.createElement(View, { style: [this.style.inputView, this.props.inputStyle] },
                    React.createElement(TextInput, { value: this.state.mySearchValue, onChangeText: this.binding.handleSearchValueChanged, placeholder: this.props.placeholder })),
                React.createElement(View, { style: this.style.button },
                    React.createElement(TouchableWithoutFeedback, { onPress: () => this.binding.handleResetPressed() },
                        React.createElement(View, null,
                            React.createElement(Text, { style: this.props.crossStyle }, "X")))))));
    }
}
